// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"usergroup_wrapper__1D5-g","header":"usergroup_header__rfI7R","footer":"usergroup_footer__3PUJX","code":"usergroup_code__31Osj"};